import { createApp } from '@app/adapters/create-app'
import markProposalAsFinalizedBtn from '../components/mark-proposal-as-finalized-btn.vue'

export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const element = doc.querySelector(
      "[data-behaviour='mark-proposal-as-finalized-btn']"
    ) as HTMLElement

    if (element) {
      createApp(markProposalAsFinalizedBtn, element.dataset).mount(element)
    }
  })
}
